import { render, staticRenderFns } from "./sectionadDialog.vue?vue&type=template&id=2e6711da"
import script from "./sectionadDialog.vue?vue&type=script&lang=js"
export * from "./sectionadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports